import { SystemMessage } from 'components/Dialogue';
import { BaseSysMsgProps } from './types';
import dayjs from 'lib/dayjs';
import { toNumber } from 'lodash-es';
import { useTranslate } from '@tolgee/react';
import { memo } from 'react';

export const SysIgnoreBotSentLimitReachedMsg = memo((props: BaseSysMsgProps) => {
  const { raw } = props;
  const { t } = useTranslate();

  const { sysIgnoreBotSentLimitReachedContent } = raw;
  return sysIgnoreBotSentLimitReachedContent ? (
    <SystemMessage>
      {t('scene.chatWorkspace.messageThread.systemMessage.ignoreBotLimitReached', {
        name: sysIgnoreBotSentLimitReachedContent.assistantName,
        datetime: dayjs(toNumber(sysIgnoreBotSentLimitReachedContent.timestamp)).format(
          'YYYY-MM-DD HH:mm:ss',
        ),
      })}
    </SystemMessage>
  ) : null;
});
